/*
 * Prestige Stacking Cards
 * -------------------------------------------------------------
 * Sticky card stack: each card is position:sticky;top:0 so the next
 * card scrolls up and covers it; the covered card's inner layer
 * scales/dims for depth and a [NN / TT] counter tracks the active card.
 *
 * Driven by a PERSISTENT requestAnimationFrame loop (never depends on
 * scroll-event frequency) so it is smooth on mobile / iOS momentum
 * scroll. Off-screen groups are skipped so idle cost is tiny.
 * Respects prefers-reduced-motion.
 */
(function () {
  if (window.__prestigeStackInit) return;
  window.__prestigeStackInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var groups = [];

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function collect() {
    groups = [];
    document.querySelectorAll('[data-stack]').forEach(function (root) {
      groups.push({
        root: root,
        cards: [].slice.call(root.querySelectorAll('.stack__card')),
        counter: root.querySelector('[data-stack-counter]')
      });
    });
  }

  function inView(root, vh) {
    var r = root.getBoundingClientRect();
    return r.bottom > 0 && r.top < vh;
  }

  function update() {
    var vh = window.innerHeight;
    for (var g = 0; g < groups.length; g++) {
      var G = groups[g];
      if (!inView(G.root, vh)) continue;
      var active = 0;
      for (var i = 0; i < G.cards.length; i++) {
        var card = G.cards[i];
        var inner = card.querySelector('.stack__inner') || card;
        if (i < G.cards.length - 1 && !reduce) {
          var nextTop = G.cards[i + 1].getBoundingClientRect().top;
          var cover = clamp((vh - nextTop) / vh, 0, 1);
          inner.style.transform = 'scale(' + (1 - 0.06 * cover).toFixed(4) + ')';
          inner.style.filter = 'brightness(' + (1 - 0.28 * cover).toFixed(3) + ')';
        } else {
          inner.style.transform = '';
          inner.style.filter = '';
        }
        if (card.getBoundingClientRect().top <= 2) active = i;
      }
      if (G.counter) G.counter.textContent = pad(active + 1);
    }
  }

  function frame() { update(); requestAnimationFrame(frame); }

  function init() {
    collect();
    if (reduce) { update(); return; }
    requestAnimationFrame(frame);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
